import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" }
const _hoisted_3 = { class: "text-center p-5 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-md" }
const _hoisted_4 = { class: "text-4xl font-bold text-white" }
const _hoisted_5 = { class: "text-center p-5 bg-gradient-to-br from-green-500 to-green-600 rounded-xl shadow-md" }
const _hoisted_6 = { class: "text-4xl font-bold text-white" }
const _hoisted_7 = { class: "text-center p-5 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl shadow-md" }
const _hoisted_8 = { class: "text-4xl font-bold text-white" }
const _hoisted_9 = { class: "bg-gray-50 rounded-xl p-4" }

import { computed } from 'vue';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { EstadoInventarioInterface } from '../interfaces/estadoInventario.interface';

interface Props {
  data?: EstadoInventarioInterface;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'inventarioChart',
  props: {
    data: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

use([CanvasRenderer, BarChart, GridComponent, TooltipComponent, LegendComponent]);

const props = __props;

const chartOption = computed(() => {
  const inventario = props.data?.data;
  if (!inventario) return {};
  
  const stockNormal = inventario.productosTotales - 
                      inventario.productosBajoStock.cantidad - 
                      inventario.productosSinStock.cantidad;

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { 
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      textStyle: { 
        color: '#1f2937',
        fontSize: 13
      },
      padding: [12, 16],
      formatter: (params: any) => {
        const p = params[0];
        return `<div style="font-weight: 600; margin-bottom: 4px;">${p.name}</div>
                <div style="color: #6b7280;">${p.value} productos</div>`;
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['Stock Normal', 'Bajo Stock', 'Sin Stock'],
      axisLabel: {
        fontSize: 12,
        fontWeight: '500',
        color: '#6b7280',
        margin: 12
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#9ca3af',
        fontSize: 11
      },
      splitLine: {
        lineStyle: { 
          color: '#f3f4f6',
          width: 1
        }
      }
    },
    series: [
      {
        name: 'Productos',
        type: 'bar',
        data: [
          { 
            value: stockNormal, 
            itemStyle: { 
              color: '#10b981',
              borderRadius: [8, 8, 0, 0]
            } 
          },
          { 
            value: inventario.productosBajoStock.cantidad, 
            itemStyle: { 
              color: '#f59e0b',
              borderRadius: [8, 8, 0, 0]
            } 
          },
          { 
            value: inventario.productosSinStock.cantidad, 
            itemStyle: { 
              color: '#ef4444',
              borderRadius: [8, 8, 0, 0]
            } 
          }
        ],
        label: {
          show: true,
          position: 'top',
          fontSize: 14,
          fontWeight: '600',
          color: '#111827',
          distance: 8
        },
        barWidth: '35%',
        emphasis: {
          focus: 'series',
          itemStyle: {
            opacity: 0.85
          }
        }
      }
    ],
    backgroundColor: 'transparent'
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "mb-4 sm:mb-6 lg:mb-8 pb-4 sm:pb-6 border-b-2 border-gradient-to-r from-blue-400 to-indigo-500",
      style: {"border-image":"linear-gradient(90deg, #3b82f6, #6366f1) 1"}
    }, [
      _createElementVNode("h3", { class: "text-xl sm:text-2xl lg:text-3xl font-black bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-1 sm:mb-2" }, " Estado del Inventario "),
      _createElementVNode("p", { class: "text-sm sm:text-base text-gray-600 font-medium" }, "Análisis visual de ingresos y pedidos")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-blue-100 text-xs font-medium uppercase tracking-wide mb-1" }, "Productos Totales", -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.data?.data.productosTotales || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-green-100 text-xs font-medium uppercase tracking-wide mb-1" }, "Total Unidades", -1)),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.data?.data.totalUnidades || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-purple-100 text-xs font-medium uppercase tracking-wide mb-1" }, "Valor Monetario", -1)),
        _createElementVNode("p", _hoisted_8, "S/ " + _toDisplayString((__props.data?.data.valorMonetario || 0).toFixed(2)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(VChart), {
        option: chartOption.value,
        loading: __props.loading,
        style: {"height":"320px"}
      }, null, 8, ["option", "loading"]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"flex justify-center gap-6 mt-4 pt-3 border-t border-gray-200\"><div class=\"flex items-center gap-2\"><div class=\"w-3 h-3 rounded-sm bg-green-500\"></div><span class=\"text-sm text-gray-700\">Stock Normal</span></div><div class=\"flex items-center gap-2\"><div class=\"w-3 h-3 rounded-sm bg-orange-500\"></div><span class=\"text-sm text-gray-700\">Bajo Stock</span></div><div class=\"flex items-center gap-2\"><div class=\"w-3 h-3 rounded-sm bg-red-500\"></div><span class=\"text-sm text-gray-700\">Sin Stock</span></div></div>", 1))
    ])
  ]))
}
}

})